import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=0e5ddf5e&scoped=true&"
import script from "./EditPassword.vue?vue&type=script&lang=js&"
export * from "./EditPassword.vue?vue&type=script&lang=js&"
import style0 from "./EditPassword.vue?vue&type=style&index=0&id=0e5ddf5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5ddf5e",
  null
  
)

export default component.exports